function maGtnInicioGestion(response) {
  let valor = '';
  let valorCambiaPanelLateral = Number;
  const matrizActionValor = [];
  let jsonActionValor = {};
  if (response.usuario_id) {
    const accionStore = 'saveProviderId';
    valorCambiaPanelLateral = 9;
    valor = response.usuario_id;
    jsonActionValor = {
      valor,
      accionStore,
    };
    matrizActionValor.push(jsonActionValor);
  }
  return ([matrizActionValor, valorCambiaPanelLateral]);
}
module.exports.gestionEstados = function gestionEstados(action, response) {
  return new Promise((resolve, reject) => {
    switch (action) {
      case 'ma_gtn_inicio_gestion':
        resolve(maGtnInicioGestion(response));
        break;
      default:
        reject('Error');
        break;
    }
  });
};




// WEBPACK FOOTER //
// ./src/js/modulosChatBox/gestion.js